import React, { useState, useEffect } from "react";
import { useLDClient } from "launchdarkly-react-client-sdk";
import PropTypes from "prop-types";

import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";

export default function AppInitializer({ children }) {
  const [isInitialized, setIsInitialized] = useState(false);
  const ldClient = useLDClient();

  useEffect(() => {
    const checkInitialization = async () => {
      try {
        if (ldClient) {
          await ldClient.waitForInitialization();
          setIsInitialized(true);
        }
      } catch (error) {
        console.error("LaunchDarkly initialization failed:", error);
        // Continue anyway after error to not block the app
        setIsInitialized(true);
      }
    };

    checkInitialization();
  }, [ldClient]);

  if (!isInitialized) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh" bgcolor="#F7F7F7">
        <CircularProgress />
      </Box>
    );
  }

  return children;
}

AppInitializer.propTypes = {
  children: PropTypes.node.isRequired,
};
